import React, { useEffect, useState } from 'react'
import { Chip } from '@mui/material'
import GroupedMultiSelect from './GroupedMultiSelect'

/**
 * Multi-select for offices, grouped by City. Each City header acts as
 * select-all for its offices. Loads /api/my-business/catalog/offices
 * once on mount. Emits an array of office codes.
 *
 *   <OfficeSlicer value={['MAD','LCN']} onChange={codes => ...}/>
 */
export default function OfficeSlicer({ value, onChange, sx }) {
	const [options, setOptions] = useState([])

	useEffect(() => {
		fetch('/api/my-business/catalog/offices', { credentials: 'include' })
			.then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
			.then(setOptions)
			.catch(() => setOptions([]))
	}, [])

	return (
		<GroupedMultiSelect
			label="Offices"
			options={options}
			value={value}
			getOptionId={o => o.code}
			getOptionLabel={o => o.name ? `${o.name} (${o.code})` : o.code}
			groupBy={o => o.city || 'Other'}
			onChange={onChange}
			renderTag={(o, tagProps) => (
				<Chip {...tagProps} key={o.code} size="small" label={o.code}/>
			)}
			sx={sx}
		/>
	)
}
